export default "__VITE_ASSET__C1Jtn1Lq__"